// TicketStatusChip.jsx — MUI Chip that maps a ticket status string to a color +
// localized label. Statuses come from the backend ticket lifecycle
// (ticket_store.cpp): four change-request classes start 'pending', incidents
// start 'reported'; terminal states are 'published' / 'rejected' / 'withdrawn'.
// An unknown status degrades gracefully to a neutral chip showing the raw value.
import { Chip } from '@mui/material';
import { useT } from '../i18n/index.mjs';
// SB-042: colors come from the one ticket-metadata registry (ticketMeta.mjs) —
// this file used to hold its own copy alongside MyTicketsPage's order list.
import { STATUS_COLOR } from '../pages/ticketMeta.mjs';

export default function TicketStatusChip({ status, size = 'small' }) {
  const t = useT();
  const color = STATUS_COLOR[status] || 'default';
  const key = `ticketStatus.${status}`;
  const label = t(key);
  return <Chip size={size} color={color} variant="filled" label={label === key ? status : label} />;
}
